import { CollabItem } from 'components/CollabItem'
import { Thread } from 'components/CommentV2/Thread/Thread'
import { List } from 'components/CollabItem/List/List'
import { ReplyItem } from 'components/CommentV2/ReplyItem/ReplyItem'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useDocStore } from 'stores/DocStore'
import { computed } from 'mobx'
import { sortBy } from 'lodash'
import { CommentableType } from 'components/ActivityEvent/Types'
import { Comment as CommentType } from 'types'
import { CommentItem } from 'components/CommentV2/CommentItem/CommentItem'
import { useState } from 'react'
import { Portal } from 'components/Portal/Portal'
import { CommentFooter } from 'components/CollaborationDrawer/CommentFooter'
import { CommentControlGroup } from 'components/CollaborationDrawer/CommentControlGroup'
import { EditorView } from 'prosemirror-view'

interface Props {
  comment: CommentType
  replyFormContainer?: HTMLDivElement | null
  readOnly?: boolean
  view?: EditorView
}

export const Comment = observer(({ comment, replyFormContainer, readOnly = false, view }: Props) => {
  const rootStore = useRootStore()
  const docStore = useDocStore()
  const replies = computed(() =>
    sortBy(docStore.rootStore.comments.getByCommentable(comment.id, CommentableType.COMMENT), 'created_at'),
  ).get()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const handleClick = () => {
    rootStore.comments.select(comment.id)
    rootStore.docStore?.collabItemsStore.selectById(comment.id)
    rootStore.comments.markAsRead(comment.id)
  }

  return (
    <CollabItem.Root onClick={handleClick}>
      <Thread items={[comment, ...replies]}>
        {!readOnly && <CommentControlGroup comment={comment} />}
        <List collapsed={isCollapsed} onToggle={() => setIsCollapsed((collapsed) => !collapsed)} itemId={comment.id}>
          <CommentItem comment={comment} hasReplies={replies.length > 0} />

          {!readOnly && replies.map((item) => <ReplyItem key={item.id} comment={item} />)}
        </List>
      </Thread>
      {replyFormContainer && view && (
        <Portal container={replyFormContainer}>
          <CommentFooter comment={comment} view={view} />
        </Portal>
      )}
    </CollabItem.Root>
  )
})
